import { useEffect } from 'react';

import validate from './UsernameFormValidation';

import UseForm from "@usas/ui-web/utils/UseForm";

const INITIAL_FORM_STATE = {
  username: ''
};

const useUsernameForm = (onSubmitFormCallback, usernameObj) => {
  const { formState, errorState, handleSubmit, updateFormState, resetForm, setFormData
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  useEffect(() => {
    if (usernameObj) {
      setFormData({
        ...formState,
        username: usernameObj.username || '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usernameObj]);

  return {
    formState,
    errorState,
    handleSubmit,
    updateFormState,
    resetForm
  };
};

export default useUsernameForm;